<!-- Global loader for whole Detail tab -->
@if (simpleTestingGroup) {
    <div>
        @if (testScoreConfig && permissions.CanViewScore) {
            <generic-list-manager [config]="testScoreConfig" #testScores></generic-list-manager>
        }

        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'simpleTestingMain.testDetailTitle' | t }}</div>
            <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                <simple-testing-testplan
                    [type]="type"
                    [standingData]="standingData"
                    [simpleTestingGroup]="simpleTestingGroup"
                    (catalogueChanged)="catalogueChanged($event)"
                >
                </simple-testing-testplan>
            </div>
        </div>
    </div>
} @else {
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'simpleTestingMain.testDetailTitle' | t }}</div>
        <div class="detail-page-card-body padded cerrix-control-sm">
            <div class="fancy-loader submodule"></div>
        </div>
    </div>
}

@if (model) {
    <control-detail-overview
        [ControlGuid]="model.ControlGuid"
        [Label]="'simpleTestingMain.linkedControlLabel' | t"
        [HideOpenControlButton]="false"
        [HideControlDetails]="false"
        [HideDesignScore]="false"
        [HideEffectivenessScore]="false"
    ></control-detail-overview>
}
